import { RequestArticleContextData } from '@/routes/Requests/contexts/interfaces';

export const computeStartArticleExchangeContext = ({
  view,
}: {
  view: RequestArticleContextData['view'];
}) => {
  view.services.exchange.replacementUniqueArticle.editable = view.details.serialNumber.shown;
};
